import React from "react";
import { Link } from "react-router-dom";
import { MdLockOutline } from "react-icons/md";

// Shown when a signed-in staff member reaches a page their role has no
// capability for. Deliberately NOT Components/UnAuthorized, which clears the
// session and sends them back to login - that is for an expired token. Here the
// session is perfectly valid, they simply lack the permission, so logging them
// out would be both wrong and confusing.
const NoPermission = ({ message = "You don't have permission to view this page." }) => (
    <div className="container py-5 text-center">
        <div className="d-flex align-items-center justify-content-center rounded-circle bg-light text-muted mx-auto mb-3" style={{ width: 72, height: 72 }}>
            <MdLockOutline size={34} />
        </div>
        <h5 className="fw-semibold mb-2">Not available</h5>
        <p className="text-muted mb-4">{message}</p>
        <Link to="/dashboard" className="btn px-4 back-btn">Back to dashboard</Link>
    </div>
);

export default NoPermission;
